import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-icon", { disabled: _ctx.disabled, 'pointer': _ctx.clickable }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicked && _ctx.clicked(...args))),
    style: _normalizeStyle(` ${_ctx.background ? 'background-color: #fff8;' : ''}`)
  }, [
    _createElementVNode("span", {
      class: "material-symbols-outlined",
      style: _normalizeStyle(`${_ctx.size ? 'font-size: ' + _ctx.size + ';' : ''} color: ${_ctx.color};`)
    }, _toDisplayString(_ctx.icon), 5)
  ], 6))
}